// extracted by mini-css-extract-plugin
export default {"status":"PolicyStatus_status__rtRuG","status_text":"PolicyStatus_status_text__2mBQ9"};